import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import LoadingSpin from '../common/LoadingSpin';

import recordActions from '../../actions/recordActions';
import AutoRefreshButton from './Timer/AutoRefreshButton';

import styles from './records.less';

class RecordsRefresh extends React.PureComponent {

  static propTypes = {
    catalog: PropTypes.object,
    scene: PropTypes.object,
    viewId: PropTypes.string,
    viewMode: PropTypes.string,
  };

  /* действие для выполнения обновления данных по флагу shouldReload */
  btnRefresh = () => {
    const { scene } = this.props;
    const sceneId = scene.get('sceneId');
    recordActions.setShouldReload(sceneId, true);
    recordActions.setTimeUntilTimerEnd(sceneId, Date.now() + 10 * 60 * 1001);
  };

  render() {
    const { scene, catalog, viewId, viewMode, t } = this.props;
    const catalogId = catalog.get('id');

    return (
      <>
        <AutoRefreshButton
          scene={scene}
          catalogId={catalogId}
          viewId={viewId}
          viewMode={viewMode}
          btnRefresh={this.btnRefresh}
        />
        <LoadingSpin
          title={t('buttons.refresh')}
          spin={scene && scene.get('loading')}
          className={styles.buttonRefresh}
          onClick={this.btnRefresh}

        />
      </>
    );
  }
}
export default withTranslation()(RecordsRefresh);
